// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { IoStatsChart, IoHelpCircleOutline, IoSunny, IoMoon, IoArrowBack, IoHeart, IoLibrary } from 'react-icons/io5';
import { Link } from 'react-router-dom';

const DarkModeToggle = () => {
    const [isDarkMode, setIsDarkMode] = useState(() => localStorage.getItem('theme') === 'dark');

    useEffect(() => {
        if (isDarkMode) {
            document.documentElement.classList.add('dark');
            localStorage.setItem('theme', 'dark');
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('theme', 'light');
        }
    }, [isDarkMode]);

    return (
        <button onClick={() => setIsDarkMode(!isDarkMode)} className="text-2xl">
            {isDarkMode ? <IoSunny /> : <IoMoon />}
        </button>
    );
};

const Header = ({ onStatsClick, onHelpClick, onArchiveClick }) => {
  return (
    <header className="flex items-center justify-between p-4 w-full max-w-2xl mx-auto">
      <div className="flex items-center space-x-4">
         <Link to="/">
          <IoArrowBack className="text-2xl" />
        </Link>
      </div>
      <div className="flex items-center space-x-4">
        <button onClick={onStatsClick} className="text-2xl"><IoStatsChart /></button>
        <button onClick={onArchiveClick} className="text-2xl"><IoLibrary /></button>
        <button onClick={onHelpClick} className="text-2xl"><IoHelpCircleOutline /></button>
        <a href="https://ko-fi.com/eliass_al" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-sm font-semibold px-3 py-1.5 border border-transparent rounded-md shadow-sm text-white bg-black dark:bg-white hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:text-gray-800 dark:hover:bg-gray-200">
          <IoHeart className="text-lg" />
          <span>Support</span>
        </a>
        <DarkModeToggle />
      </div>
    </header>
  );
};

export default Header;
